module.exports = __webpack_public_path__ + "img/icon_tanchuang1.abb4fdc1.png";